import {FormControl, Typography} from "@material-ui/core";
import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import {colors} from "../../../../../shared/colors";
import Radio from "@material-ui/core/Radio/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import PropTypes from "prop-types";
import {useInlineRadioButtonsStyles} from "./InlineRadioButtonsStyles";

const InlineRadioButtons = (props) => {
    const classes = useInlineRadioButtonsStyles();
    return (
        <FormControl component="fieldset" disabled={props.disabled}>
            <RadioGroup row value={props.value}
                        id="inlineRadioButtonsGroup"
                        onChange={props.handleChange}>
                {props.label ? <div className={classes.radioLabel}>
                    <Typography style={{color: colors.font.light}} variant="body2">{props.label}</Typography>
                </div> : null}
                {
                    props.radioButtons.map((item, idx) => {
                        return <FormControlLabel key={"inline-radio-button" + idx}
                                                 value={item.value}
                                                 control={<Radio color="primary"/>}
                                                 label={<Typography variant="body2">{item.text}</Typography>}/>
                    })
                }
            </RadioGroup>
        </FormControl>
    )
}

InlineRadioButtons.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    label: PropTypes.string,
    radioButtons: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

InlineRadioButtons.defaultProps = {
    disabled: false
}

export default InlineRadioButtons;
